<template>
  <page-edicion>
    <page-header
      :title="complejidadProyecto.descripcion"
      subtitle="Complejidad de proyecto"
      back-to="/complejidadesProyecto"
    />
    <formulario :complejidad-proyecto="complejidadProyecto" @submit="actualizar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import api from "@/services/complejidadesProyecto.js";

export default {
  components: { Formulario },
  data() {
    return {
      complejidadProyecto: {},
    };
  },
  mounted() {
    this.cargar(this.$route.params.id);
  },
  methods: {
    cargar(id) {
      api.cargar(id).then((response) => {
        this.complejidadProyecto = response.complejidadProyecto;
      });
    },
    actualizar() {
      api.actualizar(this.complejidadProyecto).then(() => {
        this.$messages.success("Se ha actualizado el registro de complejidad de proyecto");
        this.$router.push({ path: "/complejidadesProyecto" });
      });
    },
  },
};
</script>
